import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { filterTableDataAPI } from "services/CRUDServices";

export const filterNaja: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "najaBarcode",
  async (body: any) => {

    const data = await filterTableDataAPI(
      "consignment-api/consignment/api-v6/filterNaja",
      // filterUrls.postLabelStick,
      body.pageNumber,
      { ...body, pageNumber: undefined, pageSize: undefined },
      true,
      10,
      false
    );
     
    return data.data.payload;
  }
);

const initialState: any = {
  najaData: [],
  fetchpost: false,
  errorMessage: null,
  isUpdating: false,
  filter: {},
};

const NajaBarcodesSlice = createSlice({
  initialState: initialState,
  name: "najaBarcode",
  reducers: {
    clearNajaBarcodes: (state) => {
      state.najaData = [];
    },
    setFilterNajaBarcodes: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: {
    [filterNaja.fulfilled as any]: (state, action) => {
      state.najaData = action.payload;
      state.fetchPost = false;
    },
    [filterNaja.pending as any]: (state) => {
      state.fetchPost = true;
    },
    [filterNaja.rejected as any]: (state) => {
      state.fetchPost = false;
      state.errorMessage = "wrong";
    },
  },
});

export const { setFilterNajaBarcodes, clearNajaBarcodes } = NajaBarcodesSlice.actions;
export default NajaBarcodesSlice.reducer;
